import Vue from 'vue'
import VueRouter from "vue-router"

import EulaComponent from './components/eula.vue'
import LicensesComponent from './components/licenses.vue'
import NotFoundComponent from './components/notfound.vue'

import OutletsComponent from './components/outlets/outlets.vue'
import OutletComponent from './components/outlets/outlet.vue'
import ClientOutletsComponent from './components/outlets/client_outlets.vue'
import CheckInComponent from './components/outlets/check_in.vue'

import MenuComponent from './components/order/menu.vue'
import ProductComponent from './components/order/product.vue'
import CreateOrderComponent from './components/order/create_order.vue'
import PayComponent from './components/order/pay.vue'
import ProcessingComponent from './components/order/processing.vue'

import UserComponent from './components/user/show.vue'
import AddressComponent from './components/user/address.vue'
import LoginComponent from './components/user/login.vue'
import LoginSocialComponent from './components/user/login_social.vue'
import VerifyComponent from './components/user/verify.vue'
import PasswordResetComponent from './components/user/password_reset.vue'
import OrdersComponent from './components/user/orders.vue'
import OrderComponent from './components/user/order.vue'
import MultiOrderComponent from './components/user/multi_order.vue'
import ForgotPasswordComponent from './components/user/forgot_password.vue'
import SignUpComponent from './components/user/signup.vue'
import PaymentCardsComponent from './components/user/payment_cards.vue'

Vue.use(VueRouter)

function make(is_embed, store) {

    const middleware = {

        requireUser: function(to, from, next) {

            // Require user
            if (store.getters.user == null)
                return next({ name: 'Login' })

            next()
        },
    }

    let routes = [
        {
            name: 'Outlets',
            path: '/',
            component: OutletsComponent,
            props: true,
            children: [
                {
                    name: 'EULA',
                    path: '/eula',
                    component: EulaComponent,
                },
                {
                    name: 'Licenses',
                    path: '/licenses',
                    component: LicensesComponent,
                },
                {
                    name: 'User',
                    path: '/user',
                    component: UserComponent,
                    beforeEnter: middleware.requireUser,
                    children: [
                        {
                            name: 'Address',
                            path: '/address/:address_id',
                            component: AddressComponent,
                        }
                    ]
                },
                {
                    name: 'ClientOutlets',
                    path: '/:subdomain/all',
                    component: ClientOutletsComponent,
                },
                {
                    name: 'Orders',
                    path: '/orders',
                    component: OrdersComponent,
                    beforeEnter: middleware.requireUser,
                },
                {
                    name: 'PaymentCards',
                    path: '/cards',
                    component: PaymentCardsComponent,
                    beforeEnter: middleware.requireUser,
                },
                {
                    name: 'Order',
                    path: '/order/:sales_id',
                    component: OrderComponent,
                    props: true,
                },
                {
                    name: 'OrderShort',
                    path: '/o/:sales_id',
                    component: OrderComponent,
                    props: true,
                },
                {
                    name: 'OrderLegacy',
                    path: '/order/:outlet_id/:sales_id',
                    component: OrderComponent,
                    props: true,
                },
                {
                    name: 'MultiOrder',
                    path: '/multiorder/:sale_group_id',
                    component: MultiOrderComponent,
                    props: true,
                },
                {
                    name: 'MultiOrderShort',
                    path: '/m/:sale_group_id',
                    component: MultiOrderComponent,
                    props: true,
                },
                {
                    name: 'Login',
                    path: '/user/login',
                    component: LoginComponent,
                    props: true,
                    children: [
                        {
                            name: 'LoginSocial',
                            path: 'social',
                            component: LoginSocialComponent,
                        }
                    ]
                },
                {
                    name: 'Verify',
                    path: '/user/verify/:token',
                    component: VerifyComponent,
                },
                {
                    name: 'ForgotPassword',
                    path: '/user/forgotpassword',
                    component: ForgotPasswordComponent,
                },
                {
                    name: 'PasswordReset',
                    path: '/user/resetpassword/:email/:token',
                    component: PasswordResetComponent,
                },
                {
                    name: 'SignUp',
                    path: '/user/signup',
                    component: SignUpComponent,
                },
                {
                    name: 'Menu',
                    path: '/:outlet_slug',
                    component: MenuComponent,
                    props: true,
                    children: [
                        {
                            name: 'Outlet',
                            path: 'info',
                            component: OutletComponent,
                        },
                        {
                            name: 'Product',
                            path: 'product/:id',
                            component: ProductComponent,
                            props: true,
                            children: [
                                {
                                    name: 'Modifiers',
                                    path: 'modifiers',
                                    component: ProductComponent,
                                    props: true,
                                },
                            ]
                        },
                        {
                            name: 'CreateOrder',
                            path: 'order',
                            component: CreateOrderComponent,
                            children: [
                                {
                                    name: 'Pay',
                                    path: 'pay',
                                    component: PayComponent,
                                },
                            ]
                        },
                        {
                            name: 'CheckIn',
                            path: 'check_in',
                            component: CheckInComponent,
                        },
                    ]
                },
                {
                    name: 'Processing',
                    path: 'processing',
                    component: ProcessingComponent,
                },
            ]
        },
    ]

    // If embed, remove stores page and make the display_layout the new root page
    if (is_embed) {
        const menu_route = routes[0].children.find(r => r.name == 'Menu')
        const root_level_routes = routes[0].children.filter(r => r.name != 'Menu')

        routes = [menu_route]
        routes[0].children = routes[0].children.concat(root_level_routes)
    }

    // Add 404 route
    routes.push({
        path: '*',
        component: NotFoundComponent,

    })

    return new VueRouter({
        routes,
        mode: 'history',
    })
}

export default make


// WEBPACK FOOTER //
// ./src/js/router.js